import { ResponsesListItemType } from '../enums';
import { ResponsesListItem } from '../types';

export function getResponsesListItemCreatedAt(
  responsesListItem: ResponsesListItem
): Date {
  switch (responsesListItem.type) {
    case ResponsesListItemType.ArtificialProposalResponse: {
      const dateString = responsesListItem.data.created_at;
      return new Date(dateString);
    }

    case ResponsesListItemType.RequestResponse: {
      const dateString = responsesListItem.data.proposalDetail.createdAt;
      return new Date(dateString);
    }
  }
}
